import { BenchmarkInfoResume } from "@modules/benchmark/components/benchmarkInfoResume"
import { useBenchmark } from "@modules/benchmark/hooks/useBenchmark"
import { type HeroesBenchmarkDataType } from "@modules/dashboard/components/heroesBenchmarkDataType"
import { ExploreCard } from "@modules/explore/components/exploreCard/exploreCard"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { ErrorBoundary } from "react-error-boundary"
import { Suspense } from "react"

type BenchmarkHereosCardProps = {
  heroesBenchmark: HeroesBenchmarkDataType
}

export const BenchmarkHeroesCard: React.FC<BenchmarkHereosCardProps> = ({ heroesBenchmark }) => {
  const { sidebarNavigateTo } = useSidebar()
  const { data: benchmark } = useBenchmark(heroesBenchmark.id)

  const onOpenBenchmarkHeroesResume = () => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BenchmarkInfoResume benchmarkId={heroesBenchmark.id} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })
  }

  return (
    <>
      {benchmark ? (
        <ExploreCard
          item={benchmark}
          key={benchmark.id}
          onViewDetailsClick={onOpenBenchmarkHeroesResume}
          isSelected={false}
          backgroundImage={heroesBenchmark.image}
        />
      ) : (
        <LoadingSpinner />
      )}
    </>
  )
}
